document.addEventListener('click', (e) => {
  const wrapper = document.querySelector('[data-account-dropdown]');
  if (!wrapper) return;

  const trigger = wrapper.querySelector('[data-action="open-account-menu"]');
  const menu = wrapper.querySelector('[data-account-menu]');
  const isOpen = !menu.classList.contains('hidden');

  const actionElement = e.target.closest('[data-action]');
  const action = actionElement?.dataset.action;

  if (action === 'open-account-menu') {
    e.preventDefault();
    if (isOpen) {
      closeMenu(menu, trigger);
    } else {
      openMenu(menu, trigger);
    }
    return;
  }

  if (action === 'close-account-menu') {
    closeMenu(menu, trigger);
    trigger.focus();
    return;
  }

  if (isOpen && !e.target.closest('[data-account-dropdown]')) {
    closeMenu(menu, trigger);
  }
});

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const wrapper = document.querySelector('[data-account-dropdown]');
  if (!wrapper) return;

  const trigger = wrapper.querySelector('[data-action="open-account-menu"]');
  const menu = wrapper.querySelector('[data-account-menu]');
  if (menu.classList.contains('hidden')) return;

  closeMenu(menu, trigger);
  trigger.focus();
});

document.addEventListener('focusout', (e) => {
  const wrapper = document.querySelector('[data-account-dropdown]');
  if (!wrapper) return;

  const trigger = wrapper.querySelector('[data-action="open-account-menu"]');
  const menu = wrapper.querySelector('[data-account-menu]');
  if (menu.classList.contains('hidden')) return;
  if (wrapper.contains(e.target)) return;

  requestAnimationFrame(() => {
    if (!wrapper.contains(document.activeElement) && document.activeElement !== document.body) {
      closeMenu(menu, trigger);
    }
  });
});

function openMenu(menu, trigger) {
  menu.classList.remove('hidden');
  trigger.setAttribute('aria-expanded', 'true');
}

function closeMenu(menu, trigger) {
  menu.classList.add('hidden');
  trigger.setAttribute('aria-expanded', 'false');
}
